import jQuery from "jquery";
(function (far, $) {
  far.showmore = {};

  //#region Public functions ====================================================

  far.showmore.initialize = function () {
    wireShowMoreLinks();
  };

  //#endregion

  //#region Private functions ===================================================

  function wireShowMoreLinks() {
    $(".js-showmore").click(showMore);
  }

  function showMore(event) {
    event.preventDefault();

    var self = $(this),
      id = self.attr("id"),
      container = self.data("container"),
      src = self.attr("data-src"),
      onComplete = self.attr("data-oncomplete"),
      loading = self.hasClass("disabled"),
      text = self.text();

    if (!loading) {
      self.text("Laddar...");
      self.addClass("disabled");

      $.get(src)
        .done(function (data) {
          //HANTERA KNAPPEN
          var result = $(data);

          var items = result;

          var button = result.find("#" + id);

          if (button.length > 0) {
            self.attr("data-src", button.attr("data-src"));
            self.attr("href", button.attr("href"));
          } else {
            self.remove();
          }

          $(container).append(items);

          console.log(onComplete);
          if (typeof onComplete !== "undefined") {
            eval(onComplete);
          }

          self.removeClass("disabled");
          self.text(text);

          far.buttonAriaState.initialize();
        })
        .fail(function (err) {
          self.removeClass("disabled");
          self.text(text);
          console.log(err);
        });
    }
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
